import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from "lucide-react";
import './topbar.css';
import iconImage from './icon_ropa_calzado_hecho_españa.png';

const Navbar = () => {
  const [menuVisible, setMenuVisible] = useState(false); // Categories menu visibility
  const [menuOpen, setMenuOpen] = useState(false); // Blog/CONTACTO menu visibility
  const menuRef = useRef();
  const menuListRef = useRef();

  // Toggle the categories menu
  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  // Close the categories menu
  const closeMenu = () => {
    setMenuVisible(false);
  };

  // Close the Blog/CONTACTO menu
  const closeContactMenu = () => {
    setMenuOpen(false);
  };

  // Handle click outside of both menus
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close categories menu if clicked outside of it
      if (menuVisible && menuRef.current && !menuRef.current.contains(event.target)) {
        closeMenu();
      }
      
      // Close Blog/CONTACTO menu if clicked outside of it
      if (menuOpen && menuListRef.current && !menuListRef.current.contains(event.target)) {
        closeContactMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuVisible, menuOpen]);

  return (
    <div>
      {/* Header Section */}
      <div className="navbar">
        {/* Left: INICIO */}
        <div className="menuLeft">
          <ul className="alwaysVisible">
            <li className="topListItem">
              <Link to="/">
                <img src={iconImage} alt="Inicio Icon" className="menuIcon" />
              </Link>
            </li>
          </ul>
        </div>

        {/* Center: Categorías */}
        <div className="menuCenter">
          <div className="menuButton" onClick={toggleMenu}>
            Categorías
          </div>
        </div>

        {/* Right: CONTACTO */}
        <div className="menuRight">
          <button className="menuToggle" onClick={() => setMenuOpen(!menuOpen)}>
            <Menu size={32} />
          </button>
          <ul ref={menuListRef} className={`menuList ${menuOpen ? "open" : ""}`}>
            <li className="topListItem">
              <Link to="https://blog.ropaycalzadohechoenespana.com/blog">Blog</Link>
            </li>
            <li className="topListItem">
              <Link to="/contacto">Contacto</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Expandable Categories Section */}
      {menuVisible && (
        <div className="categoriesMenu" ref={menuRef}>
          <ul className="topList">
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/ropaMujer">Ropa de Mujer</Link>
            </li>
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/ropaHombre">Ropa de Hombre</Link>
            </li>
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/calzado">Calzado</Link>
            </li>
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/ropainteriorypijamas">Ropa interior</Link>
            </li>
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/banadoresybikinis">Bañadores</Link>
            </li>
            <li className="topListItem" onClick={closeMenu}>
              <Link to="/bolsosycomplementos">Bolsos</Link>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Navbar;
